<script lang="ts" setup>
import type { ProductPage } from "@/types";
const { product } = defineProps<{ product: ProductPage; uuid: string }>();
const { name, bannerGallery: images, type, use, price } = product;

const productPrice = useProductPriceName(price);

const swiperInstance = ref();

const onSwiper = (swiper: any) => {
  swiperInstance.value = swiper;
};

const goToPrev = () => {
  const currentIndex = swiperInstance?.value?.activeIndex || 0;
  if (!swiperInstance?.value?.isBeginning) {
    swiperInstance?.value?.slideTo(currentIndex - 1);
  }
};

const goToNext = () => {
  const currentIndex = swiperInstance?.value?.activeIndex || 0;
  if (!swiperInstance?.value?.isEnd) {
    swiperInstance?.value?.slideTo(currentIndex + 1);
  }
};
</script>

<template>
  <Container
    class="bg-[#FAF7F4]"
    :container-class="images.length > 1 ? '!px-0' : ''"
  >
    <div class="relative">
      <Swiper
        slides-per-view="auto"
        :space-between="10"
        :breakpoints="{
          768: {
            spaceBetween: 20,
          },
        }"
        :loop="false"
        @swiper="onSwiper"
      >
        <SwiperSlide
          v-for="item in images"
          :key="item._uid"
          class="flex items-start !w-auto"
        >
          <div class="relative">
            <div class="absolute right-0 p-2.5 z-10">
              <FavoriteButton :product-uuid="uuid" />
            </div>
            <Image
              class="hidden md:block 3xl:h-[800px] md:h-[75vh]"
              :blok="{ image: item.image, ratio: item.ratio }"
            />
            <Image
              class="md:hidden h-[320px]"
              :blok="{ image: item.mobileImage, ratio: '1x1' }"
            />
            <p
              v-if="item.caption"
              class="absolute z-10 bottom-0 right-0 px-2.5 py-1 bg-white text-black"
            >
              {{ item.caption }}
            </p>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>
  </Container>
  <Container class="bg-[#FAF7F4]">
    <div>
      <div class="flex justify-between items-center py-5 lg:pt-10 lg:pb-5">
        <h1 class="lg:text-[33px] text-[25px] font-helvetica-light">
          {{ name }}
        </h1>
        <div class="flex gap-4" :class="{ hidden: images.length <= 1 }">
          <IconArrowLeft
            class="h-11 w-11 cursor-pointer hidden lg:block"
            @click="goToPrev"
          />
          <IconArrowLeftSolid
            class="w-[30px] h-[30px] cursor-pointer lg:hidden"
            @click="goToPrev"
          />
          <IconArrowRight
            class="h-11 w-11 cursor-pointer hidden lg:block"
            @click="goToNext"
          />
          <IconArrowRightSolid
            class="w-[30px] h-[30px] cursor-pointer lg:hidden"
            @click="goToNext"
          />
        </div>
      </div>
      <div class="flex gap-x-2.5 gap-y-[5px] text-[13px] flex-wrap lg:gap-x-5">
        <div class="flex gap-x-2.5">
          <div class="font-helvetica-bold">Product type</div>
          <div>{{ type }}</div>
        </div>
        <div class="flex gap-x-2.5">
          <div class="font-helvetica-bold">Use</div>
          <div>{{ use }}</div>
        </div>
        <div class="flex gap-x-2.5">
          <div class="font-helvetica-bold">Price range</div>
          <div>{{ productPrice }}</div>
        </div>
      </div>
    </div>
  </Container>
</template>
